<template>
  <div id="waste_generation_ship">
    <div v-if="receivedData">
      <CastomGraphic
          :received-data="receivedData"
          graph-type="bar"
          index-axis="y"
          id="vehicle-waste"
          :is-title="false"
          :aspect-ratio="2"
          :data-labels="false"
          :maintain-aspect-ratio="true"
      />
     </div>
  </div>
</template>
<script>

import CMS from '@/model/cms'
import Service from '@/service/service.js'
import { mapGetters } from 'vuex'


export default {
  name: "WasteGenerationBySource",
  components: {
    CastomGraphic: () => import('@/components/graph/CastomGraphic.vue'),
  },

  computed: {
    ...mapGetters({
      userToken: 'getUserToken'
    }),
  },

  data () {
    return {
      receivedData: null,
      blockId: 'waste_generation',
      cloneElementId: 'waste_generation_ship'
    }
  },

  mounted() {
    this.getGraphData()
    Service.elementClone(this.blockId, this.cloneElementId)
  },

  methods: {
    getGraphData() {
      CMS.getGraph(this.userToken, '50').then((response) => {
        this.receivedData = response.data[0]
      })
    }
  }
}
</script>
